import { render } from "./indexnineteam.vue?vue&type=template&id=0e5744b8"
import script from "./indexnineteam.vue?vue&type=script&lang=js"
export * from "./indexnineteam.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__